// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_ARCHIVED_CAMPAIGN_ACTIVE = "Akt\u00edvne";
